import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Prevent entire page from zooming on iOS pinch gestures and double-tap zoom
if (typeof document !== 'undefined') {
  // Prevent Safari gesture zoom
  document.addEventListener('gesturestart', (e) => e.preventDefault(), { passive: false });
  document.addEventListener('gesturechange', (e) => e.preventDefault(), { passive: false });
  document.addEventListener('gestureend', (e) => e.preventDefault(), { passive: false });

  // Prevent multi-touch zoom on page UI outside canvas
  document.addEventListener(
    'touchmove',
    (e) => {
      if (e.touches.length > 1) {
        const target = e.target as HTMLElement | null;
        if (!target?.closest?.('[data-canvas-container="true"]')) {
          if (e.cancelable) e.preventDefault();
        }
      }
    },
    { passive: false }
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
